import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import MainCta from '../botones/main-cta'

import { Image } from 'cloudinary-react'

const Grid = styled.div`
  display: flex;
  border-bottom: 1px solid #f3f3f3;

  img {
    display: block;
  }

  & > div:last-child {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 30px;
  }
`

const IconContainer = styled.div`
  width: 70px;

  ${breakpoint('tablet')`
    width: 110px;
  `}

  ${breakpoint('tablet')`
    width: 130px;
  `}
`

const Text = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: ${props => props.theme.colors.grisExtraOscuro};
  margin: 0.5em 0;

  ${breakpoint('tablet')`
    font-size: 25px;
  `}

  ${breakpoint('desktop')`
    font-size: 30px;
  `}

  & > span {
    color: ${props => props.theme.colors.rojoBac};
    display: block;
  }
`

const ButtonContainer = styled.div`
  font-size: 14px;

  ${breakpoint('tablet')`
    font-size: 18px;
  `}

  ${breakpoint('tablet')`
    font-size: 25px;
  `}
`

const ImageContainer = styled.div`
  position: relative;
`

const Images = [
  {
    utm:
      '?utm_source=google&utm_medium=linkad&utm_campaign=cr-core-tjc-aw-an-gg-di-desde-tu-celular&utm_content=linkad_millasplus',
    image: 'landing-x-campana-oct-2018-2',
  },
  {
    utm:
      '?utm_source=google&utm_medium=linkad&utm_campaign=cr-core-tjc-aw-an-gg-di-desde-tu-celular&utm_content=linkad-automercado',
    image: 'landing-x-campana-oct-2018-1',
  },
]

function getImage(image) {
  const imagesUrl = 'https://res.cloudinary.com/baccredomatic/image/upload/'

  return (
    <picture>
      <source
        srcSet={`${imagesUrl}w_270,h_450,c_fill,g_east/${image}`}
        media="(max-width: 270px)"
      />
      <source
        srcSet={`${imagesUrl}w_334,h_350,c_fill,g_east/${image}`}
        media="(max-width: 334px)"
      />
      <source
        srcSet={`${imagesUrl}w_550,h_400,c_fill,g_east/${image}`}
        media="(max-width: 550px)"
      />
      <source
        srcSet={`${imagesUrl}w_680,h_420,c_fill,g_east/${image}`}
        media="(max-width: 680px)"
      />
      <source
        srcSet={`${imagesUrl}w_800,h_500,c_fill,g_east/${image}`}
        media="(max-width: 800px)"
      />
      <img
        src={`${imagesUrl}w_800,h_500,c_fill,g_east/${image}`}
        alt="¡Solicitá tu tarjeta de crédito desde tu celular!"
      />
    </picture>
  )
}

export default ({ utm, location }) => {
  const image = Images.find(i => i.utm === utm).image
  const originalUtm = location.search

  return (
    <Grid>
      <ImageContainer>{getImage(image)}</ImageContainer>
      <div>
        <IconContainer>
          <Image
            cloudName="baccredomatic"
            publicId="landing-x-campana-oct-2018-3"
            dpr="auto"
            responsive
            width="auto"
            crop="scale"
          />
        </IconContainer>
        <Text>
          <span>¡Solicitá tu tarjeta de crédito</span>
          desde tu celular!
        </Text>
        <ButtonContainer>
          <MainCta
            smallPadding
            to={`https://www.baccredomatic.com/es-cr/tarjetas/credito/solicitud${originalUtm}`}
          >
            Llená el formulario
          </MainCta>
        </ButtonContainer>
      </div>
    </Grid>
  )
}
